module.exports = __webpack_public_path__ + "static/media/brand-icons.13db00b7.eot";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/brand-icons.eot
// module id = 412
// module chunks = 0